import { render, staticRenderFns } from "./SliderBar.vue?vue&type=template&id=0f545809&scoped=true&"
import script from "./SliderBar.vue?vue&type=script&lang=js&"
export * from "./SliderBar.vue?vue&type=script&lang=js&"
import style0 from "./SliderBar.vue?vue&type=style&index=0&id=0f545809&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f545809",
  null
  
)

export default component.exports